
export const priceFormatter = (price: number | string) => {
    const separatedPrice = Number(price).toLocaleString("it-IT", {maximumFractionDigits: 2,minimumFractionDigits: 2});
    return `${separatedPrice} €`;
};
